<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';

defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <BaseSvg
    v-if="open"
    class="icon icon-reveal icon-reveal-open"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.2602 5.5998C15.2602 5.01991 14.7901 4.5498 14.2102 4.5498C13.6303 4.5498 13.1602 5.01991 13.1602 5.5998V8.3998V8.63148C11.9746 8.75759 10.6647 9.0959 9.39409 9.68806L8.07034 7.79755C7.73773 7.32252 7.083 7.20708 6.60798 7.53969C6.13295 7.87231 6.01751 8.52703 6.35012 9.00206L7.57225 10.7474C6.31701 11.6433 5.19416 12.8429 4.39441 14.3948L2.13523 13.0905C1.63303 12.8005 0.990857 12.9726 0.700907 13.4748C0.410958 13.977 0.583027 14.6192 1.08523 14.9091L3.5101 16.3091L3.61821 16.3715C3.52511 16.7004 3.44479 17.0412 3.37835 17.3943C3.2711 17.9642 3.64615 18.5131 4.21604 18.6204C4.78594 18.7276 5.33487 18.3526 5.44212 17.7827C6.40622 12.6597 11.065 10.6741 14.2102 10.6741C17.3555 10.6741 22.0142 12.6597 22.9783 17.7827C23.0856 18.3526 23.6345 18.7276 24.2044 18.6204C24.7743 18.5131 25.1494 17.9642 25.0421 17.3943C24.9631 16.9745 24.8645 16.5719 24.7481 16.1862L26.9599 14.9091C27.4621 14.6192 27.6342 13.977 27.3443 13.4748C27.0543 12.9726 26.4121 12.8005 25.9099 13.0905L23.9385 14.2287C23.1753 12.8125 22.1399 11.698 20.9847 10.8464L22.2761 9.00206C22.6087 8.52703 22.4933 7.87231 22.0182 7.53969C21.5432 7.20708 20.8885 7.32252 20.5559 7.79755L19.1808 9.76138C17.8622 9.1237 16.4939 8.7627 15.2602 8.63148V8.3998V5.5998ZM14.2987 20.4768C15.5074 20.4768 16.4872 19.497 16.4872 18.2883C16.4872 17.0796 15.5074 16.0998 14.2987 16.0998C13.0901 16.0998 12.1102 17.0796 12.1102 18.2883C12.1102 19.497 13.0901 20.4768 14.2987 20.4768ZM14.2987 22.5768C16.6672 22.5768 18.5872 20.6568 18.5872 18.2883C18.5872 15.9198 16.6672 13.9998 14.2987 13.9998C11.9303 13.9998 10.0102 15.9198 10.0102 18.2883C10.0102 20.6568 11.9303 22.5768 14.2987 22.5768Z"
      fill="currentColor"
    />
  </BaseSvg>

  <BaseSvg
    v-else
    class="icon icon-reveal icon-reveal-closed"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.26 21.7886C15.26 22.3685 14.7899 22.8386 14.21 22.8386C13.6301 22.8386 13.16 22.3685 13.16 21.7886V18.9886V18.7573C11.9743 18.6312 10.6643 18.2928 9.39367 17.7006L8.0701 19.5909C7.73748 20.0659 7.08276 20.1813 6.60773 19.8487C6.13271 19.5161 6.01726 18.8614 6.34988 18.3864L7.57185 16.6412C6.3166 15.7454 5.19376 14.5457 4.39403 12.9937L2.13499 14.298C1.63278 14.5879 0.990613 14.4158 0.700663 13.9136C0.410714 13.4114 0.582783 12.7692 1.08499 12.4793L3.50986 11.0793L3.61788 11.0169C3.52482 10.6881 3.44452 10.3474 3.3781 9.99448C3.27085 9.42459 3.6459 8.87566 4.2158 8.7684C4.78569 8.66116 5.33463 9.0362 5.44188 9.6061C6.40597 14.7291 11.0648 16.7146 14.21 16.7146C17.3552 16.7146 22.014 14.7291 22.9781 9.6061C23.0854 9.0362 23.6343 8.66116 24.2042 8.7684C24.7741 8.87566 25.1491 9.42459 25.0419 9.99448C24.9629 10.4142 24.8643 10.8167 24.7479 11.2023L26.9597 12.4793C27.4619 12.7692 27.634 13.4114 27.344 13.9136C27.0541 14.4158 26.4119 14.5879 25.9097 14.298L23.9384 13.1598C23.1752 14.5761 22.1398 15.6906 20.9846 16.5422L22.2759 18.3864C22.6085 18.8614 22.493 19.5161 22.018 19.8487C21.543 20.1813 20.8883 20.0659 20.5556 19.5909L19.1807 17.6273C17.8621 18.265 16.4938 18.6261 15.26 18.7573V18.9886V21.7886Z"
      fill="currentColor"
    />
  </BaseSvg>
</template>
